// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vYM_","option":"styles_option__S0_SQ","selected":"styles_selected__2cxmT"};